import { useState } from 'react';
import { Link } from 'react-router-dom';

import { AuthLayout } from '../components/AppShell.js';
import { Alert, Button, TextField } from '../components/ui.js';
import { authClient } from '../lib/authClient.js';

export function ForgotPasswordPage(): React.JSX.Element {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function handleSubmit(event: React.FormEvent<HTMLFormElement>): Promise<void> {
    event.preventDefault();
    setError(null);
    setBusy(true);

    try {
      await authClient.requestPasswordReset({
        email: email.trim(),
        redirectTo: `${window.location.origin}/reset-password`,
      });
      // Always report success, whether or not the address is registered:
      // anything else turns this form into an account-existence oracle.
      setSent(true);
    } catch {
      setError('We could not reach the server. Please try again.');
    } finally {
      setBusy(false);
    }
  }

  return (
    <AuthLayout
      title="Reset your password"
      subtitle="We will email you a link to choose a new one."
      footer={
        <Link to="/sign-in" className="font-medium text-fg underline">
          Back to sign in
        </Link>
      }
    >
      {sent ? (
        <Alert tone="success">
          If that email address has an account, a reset link is on its way. The link expires in one
          hour.
        </Alert>
      ) : (
        <form onSubmit={(event) => void handleSubmit(event)} className="space-y-5" noValidate>
          {error ? <Alert>{error}</Alert> : null}

          <TextField
            label="Email address"
            type="email"
            name="email"
            autoComplete="email"
            required
            value={email}
            onChange={(event) => setEmail(event.target.value)}
          />

          <Button type="submit" busy={busy} className="w-full">
            Send reset link
          </Button>
        </form>
      )}
    </AuthLayout>
  );
}
